import { Component, OnInit } from '@angular/core';
import { CustomerService } from '../service/customer.service';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { ConfirmationService } from 'primeng/api';
import { UserService } from '../shared/user.service';

@Component({
  selector: 'app-customer-list',
  templateUrl: './customer-list-reminder.component.html',
  styleUrls: ['./customer-list-reminder.component.css']
})
export class CustomerListReminderComponent implements OnInit {

  resultTable: any[] = null;
  cols: any[];
  msgs: any[] = [];
  showButtonsColumn: any = true;
  userDetails: any = null;

  constructor(private dataService: CustomerService, private router: Router, private userService: UserService) { }

  ngOnInit() {
    this.userService.getUserClaims().subscribe((data: any) => {
      this.userDetails = data;
    },
      (err: HttpErrorResponse) => {
        this.userDetails = null;
      });
    this.fillCustomers();
  }

  fillCustomers() {
    this.cols = [
      { field: 'IdentityNumber', header: 'זיהוי מעסיק' },
      { field: 'CustomerName', header: 'שם מעסיק' },
      { field: 'ContactName', header: 'שם איש קשר' },
      { field: 'ContactEmail', header: 'מייל איש קשר' },
      { field: 'ContactPhone', header: 'טלפון איש קשר' },
      { field: 'Phone', header: 'טלפון' },
      { field: 'ContactFirstName', header: 'שם פרטי' },
      { field: 'ContactLastName', header: 'שם משפחה' },
      { field: 'AllowFirstReminder', header: 'לשלוח תזכורת ראשונה' },
      { field: 'AllowSecondReminder', header: 'לשלוח תזכורת שניה' },
      

    ];

    this.dataService.getCustomerReminderList().subscribe((result: any) => {
      this.resultTable = result;
    },
      (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'תקלה בקבלת רשימת מעסיקים ');
      });

  }

  sendReminders(type, text) {
    if (!confirm('האם ברצונך להתחיל תהליך הפצת תזוכורת ' + text)) {return;}
    this.dataService.sendReminders(type).subscribe(type => {
      this.showMessage('success', '', 'הפצת תזכורות התחילה');
    },
      (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'תקלה בהפצת תזכורות');
    });
  }


  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: summaryMessage, detail: message });
  }

}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/customer-list-reminder/customer-list-reminder.component.ts